import { defaultStyle, Style } from 'utils/types/Style';

export default function measureText(
    text: string,
    style?: Partial<Style>,
    context?: CanvasRenderingContext2D
): number {
    style = { ...defaultStyle, ...style };

    context = context || document.createElement('canvas').getContext('2d')!;

    context.font = [
        style.fontStyle,
        style.fontVariant,
        style.fontWeight,
        style.fontSize,
        style.fontFamily,
    ].join(' ');

    const result = context.measureText(text);

    return result.width;
}
